
import { Component } from '@niknevis/vue-modules'
import AdminProfitBaseDialog from '@/modules/profit/components/admin/base/AdminProfitBaseDialog.vue'
import { AdminStoreProfitUseCase } from '@/modules/profit/use-cases/admin-store-profit.use-case'
import { Prop } from 'vue-property-decorator'

@Component
export default class AdminProfitCreateDialog extends AdminProfitBaseDialog {
  constructor(
    private readonly useCase: AdminStoreProfitUseCase
  ) {
    super()
  }

  @Prop({ default: 'ایجاد سود جدید' }) header: string

  protected get isLoading() {
    return this.useCase.isLoading
  }

  protected onSubmit() {
    this.useCase.execute(this.requestData)
      .onSuccess(() => {
        this.hide()
      })
  }
}
